var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 53,
    width: 53,
    height: 53,
    rx: 5,
    transform: "rotate(-90 0 53)",
    fill: "#8D8D8D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2233 34.1672L24.3308 26.2201C25.0158 26.8124 25.6751 27.3584 26.3009 27.9404C26.7979 28.4065 27.2279 28.3833 27.7147 27.9275C28.3198 27.3609 28.9611 26.833 29.6641 26.2201L36.7408 34.126C36.1253 34.2702 35.636 34.4814 35.1467 34.484C29.7079 34.508 24.269 34.508 18.8302 34.484C18.3615 34.4762 17.8928 34.2985 17.2233 34.1672Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0013 26.6991L17.3649 18.2705C18.0447 18.152 18.5057 18.0129 18.9692 18.0129C24.3205 17.9941 29.6726 17.9941 35.0256 18.0129C35.4892 18.0129 35.9501 18.1597 36.6377 18.2705L27.0013 26.6991Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2755 33.1551C16.1514 32.5916 16.0654 32.0203 16.018 31.4452C15.9974 27.9841 15.9974 24.5239 16.018 21.0645C16.018 20.5109 16.1906 19.9598 16.3193 19.1975L23.2981 25.2956L16.2755 33.1551Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7193 33.1525L30.7019 25.2982L37.6344 19.231C37.776 19.9057 37.9769 20.4336 37.9794 20.9615C38.0078 24.4792 38.0026 27.997 37.9794 31.5198C37.9315 32.0695 37.8445 32.6152 37.7193 33.1525Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16.4942,
    fill: "white",
    transform: "translate(16 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.63c9925e5a1ee3f801e14e3cfc3e8b86.svg";
export { ForwardRef as ReactComponent };